export const translations = {
  en: {
    // Nav
    nav_inugami:       'Inugami',
    nav_arbuzino:      'Six',
    nav_activity:      'Activity',
    // Short desktop header labels (match casino reference)
    nav_mint:          'Mint Arbuz',
    nav_card:          'Mint Card',
    nav_deck:          'My Cards',
    nav_connectWallet: 'Connect Wallet',
    dash_holdingsError: 'Failed to load holdings — hit REFRESH to retry',
    cards_loadError: 'Failed to load your deck — the card indexer may be down. Your cards are safe on-chain; retry in a moment.',
    dash_partialBatch: (got, want) => `Balance only covered ${got} of ${want} mints — ${got} sent`,

    // Dashboard
    dash_title1: 'Mint',
    dash_title2: 'Arbuz',
    dash_metricNetwork: 'Network',
    dash_metricMempool: 'Mempool · sat/vB',
    dash_metricArbuz:   'Your Arbuz Alkanes',
    dash_routing:       'Routing',
    dash_rebar:         'Rebar',
    dash_public:        'Public',
    dash_refresh:       'Refresh',
    dash_feeNormal:     'Normal',
    dash_feeSlow:       'Slow',
    dash_feeFast:       'Fast',
    dash_feeCustom:     'Custom',
    dash_networkFee:    'Network fee',
    dash_total:         'Total',
    dash_txCancelled:   'Transaction cancelled by user',
    err_insufficientFunds: (need, have) => `Insufficient funds: required ${need} sats to pay, available only ${have}`,
    err_notEnoughDiesel:   (need, have) => `Not enough DIESEL: an entry costs ${need}, your wallet holds ${have}`,
    err_notEnoughFrbtc:    (need, have) => `Not enough frBTC: swap needs ${need}, your wallet holds ${have}`,
    err_nftNotFound:       'Entry NFT not found in your wallet - it may still be loading or already spent',
    err_conflictingUtxo:  'This Arbuz is already being spent in a pending transaction - wait for it to confirm or pick a different one',
    err_insufficientFee:   (need) => `Insufficient funds for fee: need ${need} sats`,
    err_broadcastFailed:   (n, msg) => `Broadcast failed at tx ${n}: ${msg}`,
    err_legacyChainUnsupported: 'Batch and BTC flows need a SegWit or Taproot payment address - your wallet is using a legacy address. Switch the payment address type, or mint one at a time.',
    err_signingFailed:     'Wallet signing failed, please try again',
    err_oylSigningBroken:  'OYL Wallet currently rejects all transaction signing (a bug on their side) - please use Xverse, Unisat or OKX for now',
    err_networkTimeout:    'Something went wrong with your network connection - refresh the page and try again',
    err_walletUnreachable: "Couldn't reach your wallet. Disconnect and reconnect it in your wallet app, then try again",
    err_walletUnavailable: (w) => `${w} wallet not available`,
    err_inscriptionNode:   'Inscription node unavailable, try again',
    err_notEnoughArbuz:    'Selected UTXO must contain at least 100 ARBUZ',
    err_nodeFailedFetch:   'Node failed to fetch data for your address - refresh the page and try again',
    err_utxoSpent:         'This Arbuz UTXO is already spent (likely burned by an earlier card mint) - refresh the page and pick another one',
    err_noCleanUtxos:      'No clean BTC UTXOs found for fee payment - send clean BTC to your payment address and try again',
    err_feeTooLow:         'Fee rate is too low for the network right now - pick a higher fee and try again',
    err_broadcastRejected: 'The network rejected your transaction, please try again in a moment',
    err_rebarUnavailable:  'Rebar private pool is unavailable right now - try again or switch to Public routing',
    err_walletNotConnected:'Connect your wallet first',
    err_noArbuzSelected:   'Pick an Arbuz to mint your card',
    err_noUnisatBtc:       'No spendable BTC in your Unisat wallet to pay the fee - send some BTC to your address and try again',
    err_network:           'Network hiccup while preparing your transaction - check your connection and try again',
    err_generic:           'Something went wrong, please try again',
    toast_txSent:          'Mint transaction sent',
    toast_callTxSent:      'Call transaction sent',
    toast_txsSent:         (n) => `${n} mint transactions sent`,
    tx_transactions:       'Transactions',
    tx_copyAll:            'COPY ALL',
    tx_copied:             'COPIED ✓',
    dash_learnRisks:    'LEARN HOW IT WORKS',
    dash_noArbuz:       'No Arbuz found in your wallet. Mint one here.',
    dash_noArbuzDisconnected: 'No Arbuz found in your wallet. Connect wallet first.',
    dash_arbuzName:     'Arbuz',
    dash_totalMintedMarquee: 'TOTAL ARBUZ MINTED',
    dash_routePublicSub: 'open mempool · cheap',
    dash_routeRebarSub:  'private · safer',
    dash_stakeFee:       'Fee rate · sat/vB',
    dash_batchPulls:     'Batch · transactions amount',
    dash_batchSub:       'fat UTXO · one signature',
    dash_acaiReq:        'Fartanium contract fee',
    dash_totalCost:      'Total cost',
    dash_tut1:           'Pick a route - Rebar is safer, Public is cheaper',
    dash_tut2:           'Set your fee rate & batch size',
    dash_tut3:           'Hit Press to Mint & sign in your wallet',
    dash_ripening:       'RIPENING',
    dash_ripeningSub:    'Broadcasted to the mempool - outcome unknown until a pool includes your transaction in their block.',
    dash_selectFee:      'SELECT FEE',
    dash_pressToMint:    'PRESS TO MINT',
    dash_creatingShort:  'CREATING PSBT…',
    dash_signingShort:   'SIGNING…',
    dash_broadcastingShort: 'BROADCASTING…',
    dash_trackActivity:  'TRACK ON ACTIVITY',
    dash_plugIn:         'PLUG IN.',
    dash_titleSep:       ' ',   // EN: space between the two title spans; ZH: none (fullwidth 。)
    dash_getArbuz:       'GET ARBUZ',
    dash_connectBlurb:   'Connect a Bitcoin wallet to see your Arbuz and start minting.',
    dash_connectMintBtn: 'CONNECT WALLET',
    dash_routeNote:      'Public routes to the open mempool - cheap, but ~70% of blocks are mined by pools that drop alkane mints (the mint still costs sats). Rebar uses a private pool for ~80% success.',
    dash_trayTitle:      'YOUR ARBUZ',
    inu_marquee:         'MINER BOUNTY',
    inu_titleThe:        'THE',
    inu_titleName:       'INUGAMI',
    inu_lockedMarquee:   'Locked right now',
    send_marquee:        'DRAW',
    send_title1:         'MINT',
    send_title2:         'CARD',
    send_drawACard:      'DRAW A CARD',
    send_connectCardBtn: 'CONNECT WALLET',
    send_connectBlurb:   'Connect a Bitcoin wallet to mint your Magic Arbuz Card.',
    send_insertBurn:     'Insert an Arbuz',
    send_inserted:       'INSERTED',
    send_selectLc:       'select',
    send_mixedUtxo:      'CONTAINS OTHER ALKANES',
    send_pressMintCard:  'PRESS TO MINT CARD',
    send_youReceive:     'You receive',
    send_oneCardLabel:   '1 MAGIC ARBUZ CARD',
    cards_marquee:       'YOUR COLLECTION',
    cards_your:          'YOUR',
    cards_seeDeck:       'SEE YOUR DECK',
    cards_connectBlurb:  "Connect a Bitcoin wallet to reveal the cards you've minted.",
    cards_mintFirst:     'MINT YOUR FIRST CARD',
    cards_tapReveal:     'TAP TO REVEAL',
    cards_noTitle1:      'NO CARDS',
    cards_noTitle2:      'YET',
    cards_emptySub:      'Send 100 Arbuz during an open window and your first Magic Arbuz card lands right here.',
    act_marquee:         'ARBUZ TOKEN MINTS',
    act_floor1:          'MINT',
    act_floor2:          'FEED',
    act_tokensMinted:    'ARBUZ MINTED',
    act_peakLabel:       'peak',
    act_confirmedTitle:  'Confirmed Arbuz Mints',
    send_cost:           'Cost',
    send_need100:        'You need at least 100 Arbuz in a single UTXO to mint a card.',
    send_viewInDeck:     'VIEW ON DECK →',
    send_burnSign:       'Sign & Send',
    send_wbLast:         'Last block',
    send_wbNext:         'Next window',
    send_wbWait:         'Time to wait',
    send_cfNew:          'NEW',
    send_cfMinted:       'Card Minting',
    send_cfInscribed:    'Inscribed on-chain',

    // Send
    send_windowOpen:     'Mint Window Open',
    send_windowClosed:   'Mint Window Closed',
    send_windowFetching: 'Fetching status…',
    send_sendNow:        'MINT NOW',
    send_burning:        'Burning',
    send_selectArbuz:    'Select ARBUZ to Mint',

    // Cards
    cards_title2:        'deck',
    cards_owned:         'Owned',
    cards_statGenerated: 'Cards Generated',
    cards_statBurned:    'Total Arbuz Burned',
    cards_collection:    'Collection',
    cards_passport:      'Passport',
    cards_cardIndex:     'CARD INDEX',
    cards_block:         'BLOCK',
    cards_txIndex:       'TX INDEX',
    cards_traits:        'TRAITS',
    cards_traitBg:       'Background',
    cards_traitSymbol:   'Main Symbol',
    cards_traitBorder:   'Border',
    cards_traitGlow:     'Glow',
    cards_traitClass:    'Class',
    cards_traitNumeral:  'Numeral',
    cards_mystical:      'MYSTICAL SYMBOLS',
    cards_provenance:    'PROVENANCE',
    cards_outpoint:      'Outpoint',
    cards_alkane:        'Alkane',
    cards_mintDate:      'Mint Date',
    cards_viewExplorer:  'View on Explorer →',

    // Inugami
    inu_phrase:     'The phrase',
    inu_phraseDesc: 'A miner who writes this exact string into their coinbase scriptSig claims the entire pot.',
    inu_copied:     'Copied!',
    inu_copyPhrase: 'Copy phrase',
    inu_loadFailed: "Couldn't load bounty",
    inu_retry:      'Retry',
    inu_r01_name:   'BloodOath',
    inu_r01_desc:   'Lock DIESEL against a phrase. Any wallet can deposit any amount - funds accumulate in the contract, earmarked for whoever mines the matching coinbase.',
    inu_r02_name:   'BindSigil',
    inu_r02_desc:   'Called by a miner in the same block their coinbase scriptSig contains the exact phrase. The contract reads the coinbase on-chain, confirms the match, and sweeps the full pot to the miner.',
    inu_r03_name:   'SigilTrove',
    inu_r03_desc:   'Read-only query. Returns the total DIESEL locked for any phrase - use it to check the current bounty size before depositing.',

    // Activity
    act_refreshLabel:   'Refresh',
    act_ofCap:          (n) => `of ${n}`,
    act_last24h:        'Last 24h',
    act_confirmedMints: 'mints sent',
    act_thisBlock:      'Last Block',
    act_rate:           'Mint Rate',
    act_mintsPerHr:     'mints / hr',
    act_histTitle:      'Mints / Hour · last 24h',
    act_24hAgo:         '24h ago',
    act_now:            'now',
    act_histTip:        (n, ago) => `${n} mint txs · ${ago === 0 ? 'this hour' : ago + 'h ago'}`,
    act_filterAll:      'RECENT',
    act_filterYours:    'YOUR MINTS',
    act_hideRipening:   'HIDE RIPENING',
    act_showRipening:   'SHOW RIPENING',
    act_colTime:        'Time',
    act_colMinter:      'Minter',
    act_colCount:       'Count',
    act_colFee:         'Fee',
    act_colTxid:        'TXID',
    act_colPool:        'Pool',
    act_poolTBD:        'TBD',
    act_colStatus:      'Status',
    act_fetching:       'Fetching mints, it may take a while depending on node.',
    act_noMints:        'No mints found, try refreshing page.',
    act_youBadge:        'YOU',
    act_mintTxs:         'mint transactions',
    act_fetchError:      'Failed to load table data. Try waiting and refresh.',
    act_statsError:      "Couldn't get node data, try again",
    act_batchBadge:      'BATCH',
    act_loadMore:        (n) => `Load ${n} more`,
    act_showingOf:       (shown, total) => `showing ${shown} of ${total}`,
    act_labelRipening:   'RIPENING',
    act_subRipening:     'from the vine',
    act_labelJuicy:      'JUICY',
    act_subJuicy:        'you got it fresh',
    act_labelSpoiled:    'SPOILED',
    act_subSpoiled:      'mint reverted',
    act_labelChecking:   'CHECKING',
    act_subChecking:     'pool loading…',
    act_labelUnknown:    'POOL UNKNOWN',
    act_subUnknown:      'can\'t verify pool',

    // Connect modal
    modal_eyebrow:  'Connect',
    modal_title1:   'Choose your',
    modal_title2:   'wallet',
    modal_subtitle: 'Bitcoin - Alkanes · Select wallet to continue.',
    modal_installed: 'INSTALLED',
    modal_install:   'INSTALL →',
    modal_termsPre:  'By connecting you accept the',
    modal_termsLink: 'read-me',
    modal_errRejected: 'Request rejected in wallet',
    modal_connectFailed: 'Connection failed, please try again',

    // ═══ Arbuzino (Fireball) lottery page — shared by desktop + mobile ═══
    arb_poolMarquee: 'Pools this round',
    arb_diesel: 'DIESEL',
    // statbar
    arb_round: 'Current round',
    arb_closesIn: 'Closes in',
    arb_status: 'Status',
    arb_blocks: 'BLOCKS',
    arb_locked: 'LOCKED',
    arb_participants: 'Round Entries',
    arb_mintingClosed: (r) => `Round #${r} · Minting closed`,
    arb_checkTickets: 'Check your entries',
    arb_claimingWord: 'Claiming',
    arb_close: 'Close',
    arb_howItWorks: 'How it works',
    // phase tabs
    arb_minting: 'MINTING',
    arb_claiming: 'CLAIMING',
    // prize podium
    arb_topTier: 'TOP TIER POOL',
    arb_tier4: 'TIER IV POOL',
    arb_tier3: 'TIER III POOL',
    arb_odds5: '5+ correct · 1 in 214,826',
    arb_odds4: '4 correct · 1 in 3,024',
    arb_odds3: '3 correct · 1 in 121',
    // mint ticket
    arb_autoFill: 'Auto Fill',
    arb_clear: 'Clear',
    // batch mint play-slip
    arb_batchMint: 'BATCH MINT',
    arb_batchReady: (n) => `${n} ready`,
    arb_batchAllRandom: 'Smart Random',
    arb_batchClearAll: 'Clear all',
    arb_batchFillIn: 'Auto fill',
    arb_batchPicking: 'PICKING',
    arb_batchPicked: (ready, total) => `${ready} / ${total} ready`,
    arb_batchBuilding: 'Building batch',
    arb_batchFillAll: 'FILL ALL ENTRIES',
    arb_batchOpenTitle: 'Open batch mint',
    arb_batchRemove: 'Remove entry',
    arb_batchClose: 'Close batch',
    arb_batchClearRow: 'Clear numbers',
    arb_valid: 'VALID',
    arb_roundWord: 'ROUND',
    arb_new: 'NEW',
    arb_lucky: 'Random pick',
    arb_luckyTitle: 'Random pick - fill a fresh random six',
    arb_luckyInfo: 'Random pick - fills your entry with six random numbers. Tap again for a new set.',
    arb_pickSix: 'Pick six numbers, 0 to 63',
    arb_yourSix: 'Your six picks',
    arb_confirm: 'CONFIRM',
    arb_edit: '✎ Edit',
    arb_sellEnds: 'Sell ends',
    arb_block: 'BLOCK',
    arb_entries: 'Round Entries',
    arb_currentPool: 'Total pool',
    arb_ticketCost: 'Entry cost',
    arb_confirmedStamp: 'CONFIRMED',
    // command bar
    arb_buildingEntry: 'Building entry',
    arb_picked: '/ 6 picked',
    arb_selectSixBtn: 'SELECT YOUR SIX',
    arb_confirmSixBtn: 'CONFIRM YOUR SIX',
    arb_reviewSignBtn: 'REVIEW & SIGN',
    arb_readRules: 'Read the rules',
    // ticket row
    arb_confirmedRow: 'CONFIRMED',
    arb_confirming: 'CONFIRMING',
    arb_pendingRow: 'PENDING',
    arb_awaitingDraw: 'awaiting draw',
    arb_awaitingConf: 'awaiting confirmation',
    arb_drawInProgress: 'draw in progress',
    arb_resolvingShort: 'resolving…',
    arb_matchedSoFar: 'matched so far',
    arb_miss: 'MISS',
    arb_matched: (n) => `${n} matched`,
    arb_claimed: 'CLAIMED',
    arb_noMatches: 'NO TIER',
    arb_claim: 'CLAIM',
    arb_tierTop: 'TOP TIER',
    arb_tierIV: 'TIER IV',
    arb_tierIII: 'TIER III',
    // claim / draw stage
    arb_drawNotStarted: 'DRAW NOT STARTED',
    arb_blocksToStart: 'blocks\nto start drawing',
    arb_unclaimedStrip: (r) => `You have unclaimed DIESEL from round #${r}`,
    arb_liveDraw: (n) => `Live draw · ${n} of 6 recorded`,
    arb_finalDraw: (r) => `Final draw numbers · round #${r}`,
    arb_recordThisBall: 'Record this ball',
    arb_drawResolving: 'Draw complete — resolving…',
    arb_resolutionComplete: 'Resolution complete. Matching entries can claim their proportional share below.',
    arb_yourTickets: 'Your entries',
    arb_viewMintTx: 'View mint tx ↗',
    arb_olderRound: 'Older round',
    arb_newerRound: 'Newer round',
    arb_noEntryYet: (r) => `No entry yet · round #${r} is open`,
    arb_mintTicketBtn: 'Mint an entry',
    arb_noEntriesRound: (r) => `NO ENTRIES IN ROUND #${r}`,
    arb_noEntries: 'NO ENTRIES',
    arb_noEntriesSub: "You didn't hold an entry in this round.",
    arb_ticketsUnavailable: 'ENTRIES UNAVAILABLE',
    arb_ticketsUnavailableSub: "The indexer isn't answering, so your entries can't be read right now. They're safe on-chain — refresh later.",
    arb_roundClosed: 'ROUND CLOSED',
    arb_roundClosedSub: 'Minting has ended - the next round opens after the draw.',
    // fee chips
    arb_feeSlow: 'Slow',
    arb_feeNormal: 'Normal',
    arb_feeFast: 'Fast',
    arb_feeCustom: 'Custom',
    arb_netFeeChips: 'Network fee · sat/vB',
    arb_payWith: 'Pay with',
    // sign modal
    arb_reviewSign: 'Review & Sign',
    arb_yourSlip: 'Your slip',
    arb_officialSlip: 'Official entry slip',
    arb_yourSixPicks: 'Your six picks',
    arb_yourTicketsN: (n) => `Your ${n} entries`,
    arb_ticketsCount: (n) => `Entries × ${n}`,
    arb_roundCap: 'Round',
    arb_ticketTimes: (p) => `Entry × ${p}`,
    arb_swapEst: 'Swap (est.)',
    arb_maxSlippage: (p) => `Max slippage ${p}%`,
    arb_ticketMinted: (round) => `Entry minted into round #${round}`,
    arb_netFeeRate: (r) => `Network fee (${r} sat/vB)`,
    arb_contract: 'Contract',
    arb_total: 'TOTAL',
    arb_ticketNo: 'Entry',
    arb_stampSign: 'STAMP & SIGN',
    arb_connectWallet: 'CONNECT WALLET',
    // psbt phase labels
    arb_psbtCreating: 'CREATING PSBT…',
    arb_psbtSigning: 'SIGNING…',
    arb_psbtBroadcasting: 'BROADCASTING…',
    // keeper modal
    arb_drawBall: (slot, total) => `Draw ball ${slot} of ${total}`,
    arb_keeperNoteLead: 'This is a permissionless contract call.',
    arb_keeperNoteMid: " The next ball is recorded by whoever's transaction lands first. The keeper who lands it receives ",
    arb_keeperNoteShare: '1/6 of the 1% pool share',
    arb_keeperNoteTail: ". You're welcome to send one and help the draw move along - though doing it manually, ",
    arb_keeperNoteWarn: 'you risk losing the race to a faster transaction',
    arb_pullThe: 'DRAW THE',
    arb_next: 'NEXT',
    arb_ball: 'BALL',
    arb_networkFee: 'Network fee',
    arb_totalCost: 'Total cost',
    arb_recordBall: 'RECORD BALL',
    // claim modal / sheet
    arb_reviewClaim: 'Review & Claim',
    arb_claimSent: 'Claim sent',
    arb_youWon: 'Entry matched',
    arb_claimingSent: 'claiming sent',
    arb_willSettle: 'Will settle in your wallet',
    arb_prizeShareLab: 'Your payout share',
    arb_redeemTicket: 'Redeem your entry',
    arb_redeemTicketSub: 'Claim surrenders the position NFT for its payout',
    arb_prizeShare: 'Payout share',
    arb_surrender: 'Surrender',
    arb_youReceive: 'You receive',
    arb_signClaim: 'Sign & claim',
    // rules drawer (prose carries inline markup → rendered as HTML)
    arb_rulesKicker: 'HOW IT WORKS',
    arb_rulesTitle: 'How Six works',
    arb_rulesTabArbuzino: 'Six',
    arb_rulesTabVault: 'Wunschpunsch',
    arb_rulesLead: 'Arbuzino is a trustless, permissionless, round-based number-matching contract on Bitcoin, deployed on the <a class="alk-link" href="https://docs.subfrost.io/developer-guide/alkanes-integration" target="_blank" rel="noopener noreferrer">Alkanes</a> metaprotocol. Entries are paid in <b class="diesel-tip" title="DIESEL is the genesis token of the Alkanes metaprotocol - Arbuzino entries are paid in it and payouts are made in it.">DIESEL</b> and payouts are made in <b>DIESEL</b>. There is no operator - the contract holds the pooled DIESEL and pays matching entries according to its code.',
    arb_rulesHowTo: 'Step by step',
    arb_rulesStep1H: '01 · Mint an entry',
    arb_rulesStep1B: 'Pick <b>6 different numbers</b> between 0 and 63 and pay <b>0.069 DIESEL</b> for an entry. The entry lands in your wallet as an NFT.',
    arb_rulesStep2H: '02 · Wait for a draw',
    arb_rulesStep2B: "Each round lasts <b>1,008 blocks</b>, after it closes <b>6 numbers</b> are drawn, one per block - each number comes from that block's hash, making it random.",
    arb_rulesStep3H: '03 · Claim',
    arb_rulesStep3B: "Match <b>3, 4, or 5+</b> numbers to claim your share of that tier's pool in DIESEL. There is no time limit to redeem your entry NFT. Entries matching fewer than 3 numbers receive nothing.",
    arb_rulesPoolsH: 'Pools & payouts',
    arb_rulesPoolsP: "Only <b>3, 4, or 5+</b> matches receive a payout. Each tier has its own pool - a fixed % of every entry bought this round, plus anything rolled over from rounds with no matching entries, plus any DIESEL donated straight into that tier's pool. Your payout is that pool divided equally among all entries that hit the same tier (<b>pool ÷ matching entries</b>) - or the whole pool, if yours is the only one. The exact amount isn't fixed - it depends on the pool size and how many entries match - and the rarer the tier, the fewer entries share it.",
    arb_rulesType5B: 'Fed by <b style="color:var(--ink)">67%</b> of every entry - the top-tier pool. Match 5 to receive it (a 6-match counts here too), split equally with any other 5+ matching entries that round: <b style="color:var(--ink)">pool ÷ matching entries</b>.',
    arb_rulesType4B: 'Fed by <b style="color:var(--ink)">8%</b> of every entry. Match exactly 4, then split this pool equally with the other 4-match entries that round: <b style="color:var(--ink)">pool ÷ matching entries</b> - a single matching entry receives all of it.',
    arb_rulesType3B: 'Fed by <b style="color:var(--ink)">10%</b> of every entry. Match exactly 3, then split this pool equally with the other 3-match entries that round: <b style="color:var(--ink)">pool ÷ matching entries</b> - a single matching entry receives all of it.',
    arb_rulesMatched: 'MATCHED NUMBERS',
    arb_rulesKeeperNm: 'KEEPER',
    arb_rulesKeeperCh: 'PERMISSIONLESS',
    arb_rulesKeeperB: 'Fed by <b style="color:#4FB0E8">1%</b> of every entry - not a payout tier, it pays whoever advances the draw. Recording each of the 6 drawn balls on-chain is open to anyone (<b>RecordBall</b>): the 6 recordings split this pool equally, and the one that records the final ball - finalizing the round - receives the remainder.',
    arb_rulesCarry: "If no entry matches a specific tier, its pool isn't burned - it rolls into the next round's pool.",
    arb_rulesVaultLead: 'The wunschpunsch vault is a pool of <b>DIESEL</b> funded by fees from Arbuzino. Holders of its share token, <b>wunsch</b>, can redeem their share of the pool in DIESEL - no Arbuzino entry required.',
    arb_rulesEarnH: 'How the vault works',
    arb_rulesEarnStepsH: 'How to use the vault',
    arb_rulesGrowH: 'How the pool changes',
    arb_rulesEarnLead: "Every round, <b>14%</b> of the round's pool is swept into the vault. The sweep is permissionless - <b>anyone</b> can trigger it (the <b>DonateFeesToVault</b> opcode) - and the DIESEL it moves is added to the pool that <b>wunsch</b> holders redeem from.",
    arb_rulesEarnS1H: 'Burn a berry',
    arb_rulesEarnS1B: 'You have to use one berry - <b>ARBUZ</b>, ACAI or GOJI - the vault burns it, and you receive a share.',
    arb_rulesEarnS2H: 'Get wunsch',
    arb_rulesEarnS2B: 'Your share is a <b>wunsch</b> token - your proof of a share in the vault.',
    arb_rulesEarnS3H: 'Redeem DIESEL',
    arb_rulesEarnS3B: 'Burn wunsch anytime for your slice of the pool - paid in <b>DIESEL</b>.',
    arb_rulesEarnGrow: "The vault holds <b>DIESEL</b>, which comes in two ways: the 14% swept from each round, and direct donations. Only depositing <b>ARBUZ</b>, ACAI or GOJI mints new wunsch (the vault's shares). Each wunsch redeems for its pro-rata share of whatever the vault holds at that moment - nothing guarantees how much that will be.",
    arb_rulesEarnPayout: '<b>Your redemption:</b> your shares ÷ all shares × the pool. <b>Example:</b> the pool holds <b>10,000 DIESEL</b> and <b>1,000</b> wunsch exist in total. You hold <b>50</b> wunsch (5%), so you redeem 50 ÷ 1,000 × 10,000 = <b>500 DIESEL</b>.',
    arb_rulesPermlessH: 'Permissionless',
    arb_rulesPermlessP: "No admin and no owner. <b>Anyone</b> can call the contract's actions - like recording the draw or sweeping the fee to the vault - because the contract checks that the action is allowed by the rules, not <i>who</i> sent it. Permissionless doesn't mean abusable: e.g. the round only advances on the final ball, so no one can trigger it early.",
    arb_rulesImmutableH: 'Immutable by design',
    arb_rulesImmutableP: 'The contract has no upgrade function. The values set at deploy - entry price, round length, pool splits and the vault address - are fixed and cannot be changed by anyone, including the developers.',
    arb_rulesContractsH: 'Contracts',
    arb_rulesCxGameK: 'Game',
    arb_rulesCxTicketK: 'Entry NFT factory',
    arb_rulesCxVaultK: 'Vault',
    arb_rulesLifecycleH: 'Technical lifecycle details',
    arb_rulesLcSaleK: 'Sale (1,008 blocks ≈ 1 week)',
    arb_rulesLcSaleV: 'BuyTicket (op 1) - buy entries while the round is open',
    arb_rulesLcDonateK: 'Donate',
    arb_rulesLcDonateV: 'Donate (op 5) - anyone adds DIESEL to a tier pool, anytime',
    arb_rulesLcLockK: 'Lock',
    arb_rulesLcLockV: 'Sales close - BuyTicket rejected past lock height',
    arb_rulesLcDrawK: 'Draw',
    arb_rulesLcDrawV: 'Anyone calls RecordBall (op 2) once per block - 6 distinct blocks needed',
    arb_rulesLc6thK: '6th ball',
    arb_rulesLc6thV: 'RecordBall finalizes the draw and opens the next round in the same call',
    arb_rulesLcClaimK: 'Claim',
    arb_rulesLcClaimV: "Claim (op 3) - hand in the NFT and collect; snapshots are immutable, so there's no deadline",
    arb_rulesLcSweepK: 'Fee sweep',
    arb_rulesLcSweepV: 'DonateFeesToVault (op 6) - anyone pushes the 14% fee to the vault, anytime',
    arb_rulesVlDepositK: 'Deposit',
    arb_rulesVlDepositV: 'op 1 - burn a berry, mint wunsch shares to your address',
    arb_rulesVlDonateK: 'Donate',
    arb_rulesVlDonateV: 'op 2 - add DIESEL to the pool; no new shares are minted',
    arb_rulesVlRedeemK: 'Redeem',
    arb_rulesVlRedeemV: 'op 3 - burn wunsch for your pro-rata slice of the DIESEL pool',
    // ── mobile-specific ──
    arb_lockedIn: 'LOCKED IN',
    arb_tapSwap: 'Tap a ball to swap',
    arb_tapPick: (n) => `Tap to pick · ${n} left`,
    arb_blk: 'BLOCKS',
    arb_oneTicketTx: 'One entry · one tx',
    arb_drawPending: (r) => `Draw pending · round #${r}`,
    arb_drawingN: (n) => `Drawing · ${n} of 6 recorded`,
    arb_finalDrawShort: (r) => `Final draw · round #${r}`,
    arb_resolutionShort: 'Resolution complete — matching entries can claim below.',
    arb_sixDrawn: 'Six numbers drawn one per block, from distinct Bitcoin block hashes…',
    arb_drawBegins: 'The draw begins the moment the round locks.',
    arb_matchedUnit: 'matched',
    arb_noTicketRound: (r) => `You didn't hold an entry in round #${r}.`,
    arb_noEntryOpen: (r) => `No entry yet · round #${r} open`,
    arb_back: '← BACK',
    arb_entryLockedIn: 'Entry locked in',
    arb_committedRound: (r) => `Your six are committed to round #${r}.`,
    arb_signInWallet: 'SIGN IN WALLET',
  },

  zh: {
    // Nav
    nav_inugami:       'Inugami',
    nav_arbuzino:      'Six',
    nav_activity:      '活动',
    // Short desktop header labels (match casino reference)
    nav_mint:          '铸造 Arbuz',
    nav_card:          '铸造卡牌',
    nav_deck:          '我的牌组',
    nav_connectWallet: '连接钱包',
    dash_holdingsError: '持仓加载失败 — 点击刷新重试',
    cards_loadError: '卡组加载失败 — 卡牌索引器可能暂时不可用。你的卡牌安全地保存在链上，请稍后重试。',
    dash_partialBatch: (got, want) => `余额仅够 ${want} 笔中的 ${got} 笔 — 已发送 ${got} 笔`,

    // Dashboard
    dash_title1: '铸造',
    dash_title2: 'Arbuz',
    dash_metricNetwork: '网络',
    dash_metricMempool: '内存池 · sat/vB',
    dash_metricArbuz:   '我的 Arbuz Alkanes',
    dash_routing:       '路由',
    dash_rebar:         'Rebar',
    dash_public:        '公开',
    dash_refresh:       '刷新',
    dash_feeNormal:     '普通',
    dash_feeSlow:       '慢速',
    dash_feeFast:       '快速',
    dash_feeCustom:     '自定义',
    dash_networkFee:    '网络费',
    dash_total:         '总计',
    dash_txCancelled:   '用户取消了交易',
    err_insufficientFunds: (need, have) => `余额不足：需支付 ${need} sats，仅有 ${have} sats`,
    err_notEnoughDiesel:   (need, have) => `DIESEL 不足：每份参与需 ${need}，钱包仅有 ${have}`,
    err_notEnoughFrbtc:    (need, have) => `frBTC 不足：兑换需 ${need}，钱包仅有 ${have}`,
    err_nftNotFound:       '钱包中未找到该参与凭证 NFT - 可能仍在加载或已被花费',
    err_conflictingUtxo:  '这个 Arbuz 已在一笔待确认交易中被花费 - 请等待确认或换一个',
    err_insufficientFee:   (need) => `手续费不足：需要 ${need} sats`,
    err_broadcastFailed:   (n, msg) => `第 ${n} 笔交易广播失败：${msg}`,
    err_legacyChainUnsupported: '批量与 BTC 流程需要 SegWit 或 Taproot 付款地址 - 你的钱包正在使用传统（legacy）地址。请切换付款地址类型，或逐个铸造。',
    err_signingFailed:     '钱包签名失败，请重试',
    err_oylSigningBroken:  'OYL 钱包目前无法签名任何交易（钱包侧故障）- 请暂时使用 Xverse、Unisat 或 OKX',
    err_networkTimeout:    '您的网络连接出现问题 - 请刷新页面后重试',
    err_walletUnreachable: '无法连接到你的钱包。请在钱包 App 内断开并重新连接后重试',
    err_walletUnavailable: (w) => `${w} 钱包不可用`,
    err_inscriptionNode:   '铭文节点不可用，请重试',
    err_notEnoughArbuz:    '所选 UTXO 至少需要包含 100 ARBUZ',
    err_nodeFailedFetch:   '节点无法获取您地址的数据，请刷新页面后重试',
    err_utxoSpent:         '该 Arbuz UTXO 已被花费（可能已被之前的卡牌铸造烧毁），请刷新页面后选择其他 UTXO',
    err_noCleanUtxos:      '未找到可用于支付手续费的纯净 BTC UTXO，请向您的付款地址转入纯净 BTC 后重试',
    err_feeTooLow:         '当前费率对网络来说太低了，请选择更高的费率后重试',
    err_broadcastRejected: '网络拒绝了你的交易，请稍后再试',
    err_rebarUnavailable:  'Rebar 私有矿池暂时不可用，请重试或切换到 Public 路由',
    err_walletNotConnected:'请先连接钱包',
    err_noArbuzSelected:   '请选择一个 Arbuz 来铸造卡牌',
    err_noUnisatBtc:       'Unisat 钱包中没有可用于支付手续费的 BTC，请向你的地址转入一些 BTC 后重试',
    err_network:           '准备交易时网络出现问题，请检查网络连接后重试',
    err_generic:           '出错了，请重试',
    toast_txSent:          '铸造交易已发送',
    toast_callTxSent:      '调用交易已发送',
    toast_txsSent:         (n) => `已发送 ${n} 笔铸造交易`,
    tx_transactions:       '交易',
    tx_copyAll:            '全部复制',
    tx_copied:             '已复制 ✓',
    dash_learnRisks:    '了解运作原理',
    dash_noArbuz:       '钱包中未找到 Arbuz。在这里铸造一个。',
    dash_noArbuzDisconnected: '钱包中未找到 Arbuz。请先连接钱包。',
    dash_arbuzName:     'Arbuz',
    dash_totalMintedMarquee: 'ARBUZ 铸造总量',
    dash_routePublicSub: '公开内存池 · 便宜',
    dash_routeRebarSub:  '私有 · 更安全',
    dash_stakeFee:       '费率 · sat/vB',
    dash_batchPulls:     '批量 · 交易数量',
    dash_batchSub:       '胖 UTXO · 单次签名',
    dash_acaiReq:        'Fartanium 合约费',
    dash_totalCost:      '总费用',
    dash_tut1:           '选择路由 - Rebar 更安全\nPublic 更便宜',
    dash_tut2:           '设置费率和批量大小',
    dash_tut3:           '点击铸造并在钱包中签名',
    dash_ripening:       '催熟中',
    dash_ripeningSub:    '已广播到内存池 - 在矿池将你的交易打包进区块前，结果未知。',
    dash_selectFee:      '选择费率',
    dash_pressToMint:    '按下铸造',
    dash_creatingShort:  '构建 PSBT…',
    dash_signingShort:   '签名中…',
    dash_broadcastingShort: '广播中…',
    dash_trackActivity:  '在活动中追踪',
    dash_plugIn:         '插入。',
    dash_titleSep:       '',
    dash_getArbuz:       '获取 ARBUZ',
    dash_connectBlurb:   '连接比特币钱包，查看你的 Arbuz 并开始铸造。',
    dash_connectMintBtn: '连接钱包',
    dash_routeNote:      'Public 路由到公开内存池 - 便宜，但约 70% 的区块由会丢弃 alkane 铸造的矿池挖出（铸造仍需花费 sats）。Rebar 使用私有矿池，成功率约 80%。',
    dash_trayTitle:      '我的 ARBUZ',
    inu_marquee:         '矿工赏金',
    inu_titleThe:        'THE',
    inu_titleName:       'INUGAMI',
    inu_lockedMarquee:   '当前锁定',
    send_marquee:        '抽卡',
    send_title1:         '铸造',
    send_title2:         '卡牌',
    send_drawACard:      '抽一张卡',
    send_connectCardBtn: '连接钱包',
    send_connectBlurb:   '连接比特币钱包，铸造你的 Magic Arbuz 卡。',
    send_insertBurn:     '放入一个 Arbuz',
    send_inserted:       '已放入',
    send_selectLc:       '选择',
    send_mixedUtxo:      '含有其他 alkanes',
    send_pressMintCard:  '按下铸造卡牌',
    send_youReceive:     '你将获得',
    send_oneCardLabel:   '1 张 MAGIC ARBUZ 卡牌',
    cards_marquee:       '你的收藏',
    cards_your:          '你的',
    cards_seeDeck:       '查看你的牌组',
    cards_connectBlurb:  '连接比特币钱包，查看你铸造的卡牌。',
    cards_mintFirst:     '铸造你的第一张卡',
    cards_tapReveal:     '点击翻开',
    cards_noTitle1:      '暂无',
    cards_noTitle2:      '卡牌',
    cards_emptySub:      '在开放窗口期间发送 100 Arbuz，你的第一张 Magic Arbuz 卡牌就会出现在这里。',
    act_marquee:         'ARBUZ 代币铸造',
    act_floor1:          '铸造',
    act_floor2:          '动态',
    act_tokensMinted:    'ARBUZ 已铸造',
    act_peakLabel:       '峰值',
    act_confirmedTitle:  '已确认的 Arbuz 铸造',
    send_cost:           '费用',
    send_need100:        '你需要单个 UTXO 中至少 100 个 Arbuz 才能铸造卡牌。',
    send_viewInDeck:     '在牌组中查看 →',
    send_burnSign:       '签名并发送',
    send_wbLast:         '上一区块',
    send_wbNext:         '下一窗口',
    send_wbWait:         '等待时间',
    send_cfNew:          '新',
    send_cfMinted:       '卡牌铸造中',
    send_cfInscribed:    '已链上刻录',

    // Send
    send_windowOpen:     '铸造窗口开放',
    send_windowClosed:   '铸造窗口关闭',
    send_windowFetching: '正在获取状态…',
    send_sendNow:        '立即铸造',
    send_burning:        '燃烧',
    send_selectArbuz:    '选择 Arbuz 以铸造',

    // Cards
    cards_title2:        '牌组',
    cards_owned:         '持有数量',
    cards_statGenerated: '已生成卡牌',
    cards_statBurned:    '累计销毁 Arbuz',
    cards_collection:    '收藏',
    cards_passport:      '护照',
    cards_cardIndex:     '卡牌编号',
    cards_block:         '区块',
    cards_txIndex:       '交易索引',
    cards_traits:        '特征',
    cards_traitBg:       '背景',
    cards_traitSymbol:   '主符号',
    cards_traitBorder:   '边框',
    cards_traitGlow:     '光效',
    cards_traitClass:    '类别',
    cards_traitNumeral:  '数字',
    cards_mystical:      '神秘符号',
    cards_provenance:    '溯源',
    cards_outpoint:      '输出点',
    cards_alkane:        'Alkane',
    cards_mintDate:      '铸造日期',
    cards_viewExplorer:  '在浏览器中查看 →',

    // Inugami
    inu_phrase:     '触发短语',
    inu_phraseDesc: '矿工将此字符串写入其 coinbase scriptSig 即可领取全部赏金。',
    inu_copied:     '已复制！',
    inu_copyPhrase: '复制短语',
    inu_loadFailed: '赏金加载失败',
    inu_retry:      '重试',
    inu_r01_name:   '血誓',
    inu_r01_desc:   '将 DIESEL 锁定至短语。任何钱包均可存入任意数额--资金在合约中累积，留给挖到匹配 coinbase 的矿工。',
    inu_r02_name:   '绑定印记',
    inu_r02_desc:   '由矿工在其 coinbase scriptSig 包含该短语的同一区块中调用。合约链上读取 coinbase，确认匹配后将全部资金转给矿工。',
    inu_r03_name:   '印记宝库',
    inu_r03_desc:   '只读查询。返回任意短语当前锁定的 DIESEL 总量--可在存入前查看当前赏金规模。',

    // Activity
    act_refreshLabel:   '刷新',
    act_ofCap:          (n) => `共 ${n}`,
    act_last24h:        '过去 24 小时',
    act_confirmedMints: '笔已发送',
    act_thisBlock:      '上一区块',
    act_rate:           '铸造速率',
    act_mintsPerHr:     '次/小时',
    act_histTitle:      '每小时铸造次数 · 过去 24 小时',
    act_24hAgo:         '24小时前',
    act_now:            '现在',
    act_histTip:        (n, ago) => `${n} 次 · ${ago === 0 ? '本小时' : ago + ' 小时前'}`,
    act_filterAll:      '最近',
    act_filterYours:    '我的铸造',
    act_hideRipening:   '隐藏催熟中',
    act_showRipening:   '显示催熟中',
    act_colTime:        '时间',
    act_colMinter:      '铸造者',
    act_colCount:       '数量',
    act_colFee:         '费率',
    act_colTxid:        'TXID',
    act_colPool:        '矿池',
    act_poolTBD:        '待定',
    act_colStatus:      '状态',
    act_fetching:       '正在获取铸造记录，可能需要一些时间，具体取决于节点。',
    act_noMints:        '未找到铸造记录，请尝试刷新页面。',
    act_youBadge:        '我',
    act_mintTxs:         '铸造交易',
    act_fetchError:      '加载记录失败，数据可能已过时。',
    act_statsError:      '无法获取节点数据，请重试',
    act_batchBadge:      '批量',
    act_loadMore:        (n) => `再加载 ${n} 条`,
    act_showingOf:       (shown, total) => `显示 ${shown} / ${total}`,
    act_labelRipening:   '催熟中',
    act_subRipening:     '悬于枝头',
    act_labelJuicy:      '鲜嫩多汁',
    act_subJuicy:        '新鲜到手',
    act_labelSpoiled:    '已腐烂',
    act_subSpoiled:      '铸造已回滚',
    act_labelChecking:   '查验中',
    act_subChecking:     '矿池加载中…',
    act_labelUnknown:    '矿池未知',
    act_subUnknown:      '无法验证矿池',

    // Connect modal
    modal_eyebrow:   '连接',
    modal_title1:    '选择您的',
    modal_title2:    '钱包',
    modal_subtitle:  'Bitcoin - Alkanes · 选择钱包以继续。',
    modal_installed: '已安装',
    modal_install:   '安装 →',
    modal_termsPre:  '连接即表示您接受',
    modal_termsLink: '使用说明',
    modal_errRejected: '请求在钱包中被拒绝',
    modal_connectFailed: '连接失败，请重试',

    // ═══ Arbuzino (Fireball) 页面 — 桌面端 + 移动端共用 ═══
    arb_poolMarquee: '本轮资金池',
    arb_diesel: 'DIESEL',
    arb_round: '当前轮次',
    arb_closesIn: '截止于',
    arb_status: '状态',
    arb_blocks: '区块',
    arb_locked: '已锁定',
    arb_participants: '本轮参与数',
    arb_mintingClosed: (r) => `第 ${r} 轮 · 铸造已关闭`,
    arb_checkTickets: '查看你的参与',
    arb_claimingWord: '领取',
    arb_close: '关闭',
    arb_howItWorks: '运作原理',
    arb_minting: '铸造',
    arb_claiming: '领取',
    arb_topTier: '顶级资金池',
    arb_tier4: '四级资金池',
    arb_tier3: '三级资金池',
    arb_odds5: '匹配 5+ · 1/214,826',
    arb_odds4: '匹配 4 · 1/3,024',
    arb_odds3: '匹配 3 · 1/121',
    arb_autoFill: '自动填充',
    arb_clear: '清除',
    // batch mint play-slip
    arb_batchMint: '批量铸造',
    arb_batchReady: (n) => `${n} 份就绪`,
    arb_batchAllRandom: '智能随机',
    arb_batchClearAll: '全部清除',
    arb_batchFillIn: '自动填充',
    arb_batchPicking: '选号中',
    arb_batchPicked: (ready, total) => `${ready} / ${total} 份就绪`,
    arb_batchBuilding: '正在组建批量',
    arb_batchFillAll: '填满所有参与',
    arb_batchOpenTitle: '打开批量铸造',
    arb_batchRemove: '移除此参与',
    arb_batchClose: '关闭批量',
    arb_batchClearRow: '清除号码',
    arb_valid: '有效',
    arb_roundWord: '轮次',
    arb_new: '新',
    arb_lucky: '随机选号',
    arb_luckyTitle: '随机选号 - 重新随机填入六个号码',
    arb_luckyInfo: '随机选号 - 为你的参与随机填入六个号码。再点一次即可换一组。',
    arb_pickSix: '从 0 到 63 中选择六个号码',
    arb_yourSix: '你的六个号码',
    arb_confirm: '确认',
    arb_edit: '✎ 修改',
    arb_sellEnds: '售卖结束',
    arb_block: '区块',
    arb_entries: '本轮参与数',
    arb_currentPool: '总资金池',
    arb_ticketCost: '参与费用',
    arb_confirmedStamp: '已确认',
    arb_buildingEntry: '正在生成',
    arb_picked: '/ 6 已选',
    arb_selectSixBtn: '请选择六个号码',
    arb_confirmSixBtn: '确认六个号码',
    arb_reviewSignBtn: '确认并签名',
    arb_readRules: '查看规则',
    arb_confirmedRow: '已确认',
    arb_confirming: '确认中',
    arb_pendingRow: '待抽号',
    arb_awaitingDraw: '等待抽号',
    arb_awaitingConf: '等待确认',
    arb_drawInProgress: '抽号进行中',
    arb_resolvingShort: '结算中…',
    arb_matchedSoFar: '当前匹配',
    arb_miss: '未匹配',
    arb_matched: (n) => `匹配 ${n} 个`,
    arb_claimed: '已领取',
    arb_noMatches: '未达档位',
    arb_claim: '领取',
    arb_tierTop: '顶级档',
    arb_tierIV: '四级档',
    arb_tierIII: '三级档',
    arb_drawNotStarted: '抽号未开始',
    arb_blocksToStart: '区块后\n开始抽号',
    arb_unclaimedStrip: (r) => `你在第 ${r} 轮有未领取的 DIESEL`,
    arb_liveDraw: (n) => `实时抽号 · 已记录 ${n}/6`,
    arb_finalDraw: (r) => `最终抽号结果 · 第 ${r} 轮`,
    arb_recordThisBall: '记录此号码',
    arb_drawResolving: '抽号完成 — 结算中…',
    arb_resolutionComplete: '结算已完成。匹配的参与可在下方按比例领取其份额。',
    arb_yourTickets: '我的参与',
    arb_viewMintTx: '查看铸造交易 ↗',
    arb_olderRound: '较早轮次',
    arb_newerRound: '较新轮次',
    arb_noEntryYet: (r) => `尚无参与 · 第 ${r} 轮开放中`,
    arb_mintTicketBtn: '铸造参与凭证',
    arb_noEntriesRound: (r) => `第 ${r} 轮无参与`,
    arb_noEntries: '无参与',
    arb_noEntriesSub: '你在本轮没有参与。',
    arb_ticketsUnavailable: '暂时无法读取参与记录',
    arb_ticketsUnavailableSub: '索引器暂时无响应，无法读取你的参与记录。它们已安全记录在链上——请稍后刷新重试。',
    arb_roundClosed: '轮次已关闭',
    arb_roundClosedSub: '铸造已结束 - 下一轮将在抽号后开放。',
    arb_feeSlow: '慢速',
    arb_feeNormal: '普通',
    arb_feeFast: '快速',
    arb_feeCustom: '自定义',
    arb_netFeeChips: '网络费 · sat/vB',
    arb_payWith: '支付方式',
    arb_reviewSign: '确认并签名',
    arb_yourSlip: '你的参与单',
    arb_officialSlip: '正式参与单',
    arb_yourSixPicks: '你选的六个号码',
    arb_yourTicketsN: (n) => `你的 ${n} 份参与`,
    arb_ticketsCount: (n) => `参与 × ${n}`,
    arb_roundCap: '轮次',
    arb_ticketTimes: (p) => `参与 × ${p}`,
    arb_swapEst: '兑换 (估)',
    arb_maxSlippage: (p) => `最大滑点 ${p}%`,
    arb_ticketMinted: (round) => `参与凭证已铸入第 ${round} 轮`,
    arb_netFeeRate: (r) => `网络费 (${r} sat/vB)`,
    arb_contract: '合约',
    arb_total: '合计',
    arb_ticketNo: '参与',
    arb_stampSign: '盖章并签名',
    arb_connectWallet: '连接钱包',
    arb_psbtCreating: '正在创建 PSBT…',
    arb_psbtSigning: '正在签名…',
    arb_psbtBroadcasting: '正在广播…',
    arb_drawBall: (slot, total) => `抽取第 ${slot} / ${total} 个号码`,
    arb_keeperNoteLead: '这是一次无需许可的合约调用。',
    arb_keeperNoteMid: '下一个号码由交易最先落地的人记录。成功记录的 keeper 将获得',
    arb_keeperNoteShare: '资金池 1% 份额的 1/6',
    arb_keeperNoteTail: '。欢迎你发送一笔来帮助抽号推进 - 不过手动操作时，',
    arb_keeperNoteWarn: '你可能在与更快的交易竞速中落败',
    arb_pullThe: '抽取',
    arb_next: '下一个',
    arb_ball: '号码',
    arb_networkFee: '网络费',
    arb_totalCost: '总花费',
    arb_recordBall: '记录号码',
    arb_reviewClaim: '确认领取',
    arb_claimSent: '领取已发送',
    arb_youWon: '参与已匹配',
    arb_claimingSent: '领取交易已发送',
    arb_willSettle: '将结算到你的钱包',
    arb_prizeShareLab: '你的派付份额',
    arb_redeemTicket: '兑换你的参与凭证',
    arb_redeemTicketSub: '领取将交还持仓 NFT 以换取派付',
    arb_prizeShare: '派付份额',
    arb_surrender: '交还',
    arb_youReceive: '你将获得',
    arb_signClaim: '签名领取',
    arb_rulesKicker: '运作原理',
    arb_rulesTitle: 'Six 如何运作',
    arb_rulesTabArbuzino: 'Six',
    arb_rulesTabVault: 'Wunschpunsch',
    arb_rulesLead: 'Arbuzino 是比特币上无需信任、无需许可、按轮次进行的号码匹配合约，部署在 <a class="alk-link" href="https://docs.subfrost.io/developer-guide/alkanes-integration" target="_blank" rel="noopener noreferrer">Alkanes</a> 元协议上。参与费用以 <b class="diesel-tip" title="DIESEL 是 Alkanes 元协议的创世代币 - Arbuzino 的参与费用和派付都以它结算。">DIESEL</b> 支付，派付也以 <b>DIESEL</b> 结算。没有运营方 - 合约持有汇集的 DIESEL，并按其代码向匹配的参与派付。',
    arb_rulesHowTo: '步骤',
    arb_rulesStep1H: '01 · 铸造参与凭证',
    arb_rulesStep1B: '从 0 到 63 里选 <b>6 个不同的号码</b>，支付 <b>0.069 DIESEL</b> 获得一份参与。参与凭证会作为 NFT 出现在你的钱包里。',
    arb_rulesStep2H: '02 · 等待抽号',
    arb_rulesStep2B: '每轮持续 <b>1,008 个区块</b>，结束后抽出 <b>6 个号码</b>，每个区块抽一个 - 每个号码来自该区块的哈希，使其随机。',
    arb_rulesStep3H: '03 · 领取',
    arb_rulesStep3B: '匹配 <b>3、4 或 5+</b> 个号码，即可领取该档位资金池中属于你的 DIESEL 份额。赎回参与凭证 NFT 没有时间限制。匹配少于 3 个号码的参与不会获得任何派付。',
    arb_rulesPoolsH: '资金池与派付',
    arb_rulesPoolsP: '只有匹配 <b>3、4 或 5+</b> 才会获得派付。每个档位都有自己的资金池 - 由本轮每份参与的固定 % 注入，外加无人匹配轮次滚存的部分，以及任何人直接捐入该档位资金池的 DIESEL。你的派付 = 该资金池在所有匹配同一档位的参与之间平分（<b>资金池 ÷ 匹配参与数</b>）- 若只有你这一份，则为整个资金池。具体金额无法事先确定 - 取决于资金池大小以及匹配的参与数量 - 档位越稀有，分享它的参与越少。',
    arb_rulesType5B: '由每份参与的 <b style="color:var(--ink)">67%</b> 注入 - 顶级资金池。匹配 5 个即可获得（匹配 6 个也计入此档），与本轮其他匹配 5+ 的参与平分：<b style="color:var(--ink)">资金池 ÷ 匹配参与数</b>。',
    arb_rulesType4B: '由每份参与的 <b style="color:var(--ink)">8%</b> 注入。恰好匹配 4 个，与本轮其他匹配 4 个的参与平分此资金池：<b style="color:var(--ink)">资金池 ÷ 匹配参与数</b> - 若只有一份匹配，则获得全部。',
    arb_rulesType3B: '由每份参与的 <b style="color:var(--ink)">10%</b> 注入。恰好匹配 3 个，与本轮其他匹配 3 个的参与平分此资金池：<b style="color:var(--ink)">资金池 ÷ 匹配参与数</b> - 若只有一份匹配，则获得全部。',
    arb_rulesMatched: '个匹配号码',
    arb_rulesKeeperNm: '记录者',
    arb_rulesKeeperCh: '无需许可',
    arb_rulesKeeperB: '由每份参与的 <b style="color:#4FB0E8">1%</b> 注入 - 这不是派付档位，而是支付给推进抽号的人。链上记录 6 个抽出号码中的每一个都对所有人开放（<b>RecordBall</b>）：这 6 次记录平分该资金池，记录最后一个号码（完成本轮）的那次获得余数。',
    arb_rulesCarry: '如果某个档位没有匹配的参与，该资金池不会被销毁 - 而是滚入下一轮的资金池。',
    arb_rulesVaultLead: 'wunschpunsch 金库是一个由 Arbuzino 手续费注入的 <b>DIESEL</b> 资金池。持有其份额代币 <b>wunsch</b> 的人可以按份额赎回池中的 DIESEL - 无需参与 Arbuzino。',
    arb_rulesEarnH: '金库如何运作',
    arb_rulesEarnStepsH: '如何使用金库',
    arb_rulesGrowH: '资金池如何变化',
    arb_rulesEarnLead: '每一轮都会把本轮资金池的 <b>14%</b> 扫进金库。这个归集是无需许可的 - <b>任何人</b>都能触发（<b>DonateFeesToVault</b> 操作码） - 被转入的 DIESEL 会加进供 <b>wunsch</b> 持有者赎回的资金池。',
    arb_rulesEarnS1H: '销毁一枚浆果',
    arb_rulesEarnS1B: '你需要用一枚浆果 - <b>ARBUZ</b>、ACAI 或 GOJI - 金库会销毁它，你则获得一份份额。',
    arb_rulesEarnS2H: '得到 wunsch',
    arb_rulesEarnS2B: '你的份额就是一枚 <b>wunsch</b> 代币 - 你在金库中所占份额的凭证。',
    arb_rulesEarnS3H: '赎回 DIESEL',
    arb_rulesEarnS3B: '随时销毁 wunsch，按份额领走资金池里的一份 - 以 <b>DIESEL</b> 支付。',
    arb_rulesEarnGrow: '金库里装的是 <b>DIESEL</b>，来源有两种：每轮被扫入的 14%，以及直接捐赠。只有存入 <b>ARBUZ</b>、ACAI 或 GOJI 才会增发新的 wunsch（即金库份额）。每枚 wunsch 可按比例赎回赎回时金库中持有的 DIESEL - 具体能赎回多少不作任何保证。',
    arb_rulesEarnPayout: '<b>你的赎回额：</b>你的份额 ÷ 总份额 × 资金池。<b>举例：</b>资金池里有 <b>10,000 DIESEL</b>，总共存在 <b>1,000</b> 枚 wunsch。你持有 <b>50</b> 枚 wunsch（占 5%），那么你可赎回 50 ÷ 1,000 × 10,000 = <b>500 DIESEL</b>。',
    arb_rulesPermlessH: '无需许可',
    arb_rulesPermlessP: '没有管理员，也没有所有者。<b>任何人</b>都能调用合约的操作 - 比如记录抽号或把手续费扫进金库 - 因为合约只检查该操作是否被规则允许，而不管<i>是谁</i>发起。无需许可并不意味着可以被滥用：例如，轮次只会在最后一个号码抽出时推进，所以谁都无法提前触发。',
    arb_rulesImmutableH: '设计上不可变',
    arb_rulesImmutableP: '合约没有升级功能。部署时设定的参数 - 参与价格、轮次长度、资金池分配和金库地址 - 都是固定的，任何人（包括开发者）都无法更改。',
    arb_rulesContractsH: '合约',
    arb_rulesCxGameK: '游戏',
    arb_rulesCxTicketK: '参与凭证 NFT 工厂',
    arb_rulesCxVaultK: '金库',
    arb_rulesLifecycleH: '生命周期技术细节',
    arb_rulesLcSaleK: '售卖（1,008 区块 ≈ 1 周）',
    arb_rulesLcSaleV: 'BuyTicket（op 1）- 在本轮开放期间购买参与',
    arb_rulesLcDonateK: '捐赠',
    arb_rulesLcDonateV: 'Donate（op 5）- 任何人可随时向某个档位资金池注入 DIESEL',
    arb_rulesLcLockK: '锁定',
    arb_rulesLcLockV: '停止售卖 - 超过锁定高度后 BuyTicket 被拒绝',
    arb_rulesLcDrawK: '抽号',
    arb_rulesLcDrawV: '任何人每区块调用一次 RecordBall（op 2）- 需要 6 个不同区块',
    arb_rulesLc6thK: '第 6 个号码',
    arb_rulesLc6thV: 'RecordBall 在同一次调用中完成抽号并开启下一轮',
    arb_rulesLcClaimK: '领取',
    arb_rulesLcClaimV: 'Claim（op 3）- 交回 NFT 即可领取；快照不可变，因此没有截止期限',
    arb_rulesLcSweepK: '手续费归集',
    arb_rulesLcSweepV: 'DonateFeesToVault（op 6）- 任何人可随时将 14% 手续费推入金库',
    arb_rulesVlDepositK: '存入',
    arb_rulesVlDepositV: 'op 1 - 销毁一枚浆果，向你的地址铸造 wunsch 份额',
    arb_rulesVlDonateK: '捐赠',
    arb_rulesVlDonateV: 'op 2 - 向资金池注入 DIESEL；不增发新份额',
    arb_rulesVlRedeemK: '赎回',
    arb_rulesVlRedeemV: 'op 3 - 销毁 wunsch，按比例领取 DIESEL 资金池中的一份',
    // ── 移动端专用 ──
    arb_lockedIn: '已锁定',
    arb_tapSwap: '点击球可替换',
    arb_tapPick: (n) => `点击选择 · 还剩 ${n} 个`,
    arb_blk: '区块',
    arb_oneTicketTx: '一份参与 · 一笔交易',
    arb_drawPending: (r) => `等待抽号 · 第 ${r} 轮`,
    arb_drawingN: (n) => `抽号中 · 已记录 ${n}/6`,
    arb_finalDrawShort: (r) => `最终抽号 · 第 ${r} 轮`,
    arb_resolutionShort: '结算完成 — 匹配的参与可在下方领取。',
    arb_sixDrawn: '六个号码每区块抽出一个，分别取自不同的比特币区块哈希…',
    arb_drawBegins: '轮次锁定即刻开始抽号。',
    arb_matchedUnit: '匹配',
    arb_noTicketRound: (r) => `你在第 ${r} 轮没有参与。`,
    arb_noEntryOpen: (r) => `尚无参与 · 第 ${r} 轮开放中`,
    arb_back: '← 返回',
    arb_entryLockedIn: '参与已锁定',
    arb_committedRound: (r) => `你的六个号码已提交至第 ${r} 轮。`,
    arb_signInWallet: '在钱包中签名',
  },
};
